module.exports = __webpack_public_path__ + "img/stars-svg.5b20b022.svg";